import {SimpleChanges} from '@angular/core';
import {get, isEqual} from 'lodash-es';

export function hasChanged(changes: SimpleChanges, key: string, ...path: string[]): boolean {
  const a = get(changes, [key, 'currentValue', ...path]);
  const b = get(changes, [key, 'previousValue', ...path]);

  return !isEqual(a, b);
}
